import React from 'react';
import { connect } from 'react-redux';

import Navbar from '../../../../../_components/common/Navbar';
import SideNavBar from '../../../../../_components/common/SideNavBar'
import { orgAdminAreaData, AnalyzeData } from '../../../OrgAdminArea/SidebarData'
import AnalysisNavBar from '../../../../../_components/common/AnalysisNavBar'
import EmployeeDepartmentTable from '../../../../../_components/common/EmployeeDepartmentTable';
import { saveModulePermissionsAction, orgAdminAction, saveTeamDetailsAction, analyseActions } from '../../../../../_actions';


class HiringProbability extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            teamName: '',
            teamId: '',
            getPaUserPermissionListResponse: '',
            navData: [{
                navName: "Analyze",
                link: `/organisation/${props.match.params.id}/user`
            },
            {
                navName: "Org Admin Area",
                link: `/organisation/${props.match.params.id}/org-admin`
            },
            {
                navName: "Super Admin Area",
                link: `/organisation/${props.match.params.id}/super-admin`
            }],
            attritionData: [
                {
                    'employeeName': 'Remya Hariharan',
                    'department': 'Marketing',
                },
                {
                    'employeeName': 'Prasad',
                    'department': 'Admin',
                },
                {
                    'employeeName': 'Prabhat',
                    'department': 'Technical',
                },
                {
                    'employeeName': 'Sampath J M',
                    'department': 'Training',
                },
                {
                    'employeeName': 'Kalpana Sampath',
                    'department': 'Training',
                }, {
                    'employeeName': 'Remya Hariharan',
                    'department': 'Marketing',
                },
                {
                    'employeeName': 'Prasad',
                    'department': 'Admin',
                },
                {
                    'employeeName': 'Prabhat',
                    'department': 'Technical',
                },
                {
                    'employeeName': 'Sampath J M',
                    'department': 'Training',
                },
                {
                    'employeeName': 'Kalpana Sampath',
                    'department': 'Training',
                },
            ],
        }
    }

    componentDidMount() {
        this.props.dispatch(saveModulePermissionsAction.requestModulePermissionsHandler())
        if (this.props.saveModulePermissionsResponse === '') {
            const fd = {
                "pa_user_email": localStorage.getItem('user_email'),
                "organisation_id": +this.props.match.params.id
            }
            this.props.dispatch(orgAdminAction.getModulePermissionListHandler(fd, () => {
                this.props.dispatch(saveModulePermissionsAction.saveModulePermissionsHandler(this.props.getModulePermissionsListResponse))
                this.props.dispatch(saveModulePermissionsAction.requestModulePermissionsHandler())

            }))
        }
        else {
            this.props.saveModulePermissionsResponse.filter(
                (data, i) => {
                    if (data.module_list__module_name === 'Hiring Probability') {
                        return data
                    }
                }
            ).length === 0 &&
                this.props.history.push(`/organisation/${this.props.match.params.id}/user/dashboard`)

        }
        this.props.dispatch(saveTeamDetailsAction.requestSaveTeamDetailHandler())
        if (this.props.saveTeamDetailsResponse === '') {
            const fd1 = {
                "pa_user_email": localStorage.getItem('user_email'),
                "analytic_organisation_id": +this.props.match.params.id,
            }
            this.props.dispatch(orgAdminAction.getPaUserPermissionListHandler(fd1, () => {
                const reformatdata1 = this.props.getPaUserPermissionListResponse
                this.setState({
                    teamName: reformatdata1.length > 0 ? reformatdata1[0].analytics_team__team_name : '',
                    teamId: reformatdata1.length > 0 ? reformatdata1[0].analytics_team_id : '',
                });
                const fd = {
                    'teamName': reformatdata1.length > 0 ? reformatdata1[0].analytics_team__team_name : '',
                    'teamId': reformatdata1.length > 0 ? reformatdata1[0].analytics_team_id : '',
                    'orgId': +this.props.match.params.id
                }
                this.props.dispatch(saveTeamDetailsAction.saveTeamDetailHandler(fd))

                let assessorIds = [];
                let assessmentIds = [];
                if (reformatdata1.length !== 0 && reformatdata1 !== '') {
                    const team = {
                        "team_id": reformatdata1[0].analytics_team_id
                    }
                    this.props.dispatch(analyseActions.getAssessorGroupsHandler(team, () => {
                        this.props.dispatch(analyseActions.saveAssessorGroups(this.props.assessorGroupsResponse))

                        const assessorGroups = this.props.assessorGroupsResponse
                        for (let i = 0; i < assessorGroups.assessor_groups_for_team.length; i++) {
                            assessorIds.push(assessorGroups.assessor_groups_for_team[i].id)
                        }
                        for (let i = 0; i < assessorGroups.team_members.length; i++) {
                            assessmentIds.push(assessorGroups.team_members[i].assessment.id)
                        }
                        const fd = {
                            "assessorIds": assessorIds,
                            "assessmentIds": assessmentIds,
                        }
                        this.props.dispatch(analyseActions.saveAssessorIds(fd))
                    }))
                } else {
                    this.props.dispatch(analyseActions.saveAssessorGroups())
                    const fd = {
                        "assessorIds": assessorIds,
                        "assessmentIds": assessmentIds,
                    }
                    this.props.dispatch(analyseActions.saveAssessorIds(fd))
                }

                localStorage.setItem('teamId', reformatdata1.length > 0 ? reformatdata1[0].analytics_team_id : '')
                localStorage.setItem('teamName', reformatdata1.length > 0 ? reformatdata1[0].analytics_team__team_name : '')
            }))
        }
        else {
            const { teamId, teamName } = this.props.saveTeamDetailsResponse
            this.setState({
                teamName: teamName,
                teamId: teamId,
            });
            localStorage.setItem('teamId', teamId)
            localStorage.setItem('teamName', teamName)
        }
    }

    // onChangeTeam = (teamDetails) => {
    //     const team = {
    //         "team_id": teamDetails.analytics_team_id
    //     }
    //     this.props.dispatch(analyseActions.getAssessorGroupsHandler(team, () => {
    //         this.props.dispatch(analyseActions.saveAssessorGroups(this.props.assessorGroupsResponse))
    //     }))
    // }

    render() {
        const { navData } = this.state;
        const { saveAssesorGroupListResponse } = this.props;


        return (
            <div>
                <Navbar navItems={navData} backgroundColor="black" />
                < div className="container-post-nav">
                    {
                       <SideNavBar
                       analyzeFilterData={saveAssesorGroupListResponse !== '' ? saveAssesorGroupListResponse : null}
                       isAnalyse = {true}
                       organisationName={localStorage.getItem('orgName')}
                       orgId={this.props.match.params.id}
                       teamId={this.state.teamId}
                       teamName={this.state.teamName}
                   // onChangeTeam={(data) => this.onChangeTeam(data)}
                   />
                    }
                    <div className="analyz-container">
                        <AnalysisNavBar analyticsData={this.props.saveModulePermissionsResponse} orgId={this.props.match.params.id} analyticsType={'people'} />
                        <div className="swot-container-sub">
                            <p className=" text-center font-weight-bold mt-5">Candidates having Higher Probability of joining</p>
                            <EmployeeDepartmentTable
                                headings={[
                                    {
                                        headingName: 'Employee',
                                        headingColor: 'bg-success'
                                    }, {
                                        headingName: 'Department',
                                        headingColor: 'bg-success'
                                    }
                                ]}
                                attritionData={this.state.attritionData}
                            // Tooltip={this.state.Tooltip}
                            // selected_route_parameter={this.state.selected_route_parameter}
                            // onClickEmployee = {(key)=>this.onClickEmployee(key)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


function mapStateToProps(state) {
    const saveModulePermissionsResponse = state.saveModulePermissionsReducer.data;

    const { getModulePermissionsLoading } = state.getModulePermissionsListReducer;
    const getModulePermissionsListError = state.getModulePermissionsListReducer.error;
    const getModulePermissionsListResponse = (!getModulePermissionsLoading && !getModulePermissionsListError) ? state.getModulePermissionsListReducer.data.data.message : '';

    const saveTeamDetailsResponse = state.saveTeamDetailsReducer.data;

    const { getPaUserPermissionListLoading } = state.getPaUserPermissionListReducer;
    const getPaUserPermissionListError = state.getPaUserPermissionListReducer.error;
    const getPaUserPermissionListResponse = (!getPaUserPermissionListLoading && !getPaUserPermissionListError) ? state.getPaUserPermissionListReducer.data.data.message : '';

    const { assessorGroupsLoading } = state.assessorGroupsReducer;
    const assessorGroupsError = state.assessorGroupsReducer.error;
    const assessorGroupsResponse = (!assessorGroupsLoading && !assessorGroupsError) ? state.assessorGroupsReducer.data.data : '';

    const saveAssesorGroupListResponse = state.saveAssesorGroupListReducer.data;
    const saveAssesorIdsResponse = state.saveAssesorIdsReducer.data;


    return {
        saveModulePermissionsResponse,
        getModulePermissionsListResponse,
        saveTeamDetailsResponse,
        getPaUserPermissionListResponse,
        assessorGroupsResponse,
        saveAssesorGroupListResponse,
        saveAssesorIdsResponse
    }
}

export default connect(mapStateToProps)(HiringProbability)


// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/Category/HiringProbability/index.js